import axios from "axios";
import { BASIC_SETTINGS_URL,PAYMENT_ADJUSTMENT_TYPE_URL,GET_ALL_PAYMENT_ACCOUNTS, CURRENCY_SETTINGS_URL, PRESIGNED_URL, GET_ALL_CUSTOM_PAGES_URL, NMI_AUTH_URL ,PUBLIC_PAYMENT_URL,REGISTERED_DEVICES_URL,NMI_KEYS_URL,GET_IFRAMES_FOR_WHATSAPP_URL, BACKGROUND_TASK_STATUS} from "../../../../../constants/config";
export function getPresignedUrl(key) {
  key = key.replaceAll(" ", "-");
  return axios.post(PRESIGNED_URL, [{ key: key }]);
}
export function uploadFileToCloud(payload) {
  return fetch(payload.url, {
    method: "PUT",
    body: payload.file,
  });
}
export function getBasicSettings() {
  return axios.get(BASIC_SETTINGS_URL);
}
export function getBasicSettingsForPortal() {
  return axios.get(BASIC_SETTINGS_URL + "?type=admin-panel&sub_type=basic");
}
export function getBasicSettingsEcom() {
  return axios.get(BASIC_SETTINGS_URL + "?type=ecom&sub_type=basic,guest_user_restrictions");
}
export function getBasicSettingsEcomGuest() {
  return axios.get(BASIC_SETTINGS_URL + "?type=ecom&sub_type=guest_user_restrictions");
}
export function getBasicSettingsEcomNonGuest() {
  return axios.get(BASIC_SETTINGS_URL + "?type=ecom&sub_type=basic");
}
export function getThemeSettingsEcomNonGuest() {
  return axios.get(BASIC_SETTINGS_URL + "?type=ecom&sub_type=theme");
}
export function getBasicSettingsAdmin() {
  return axios.get(BASIC_SETTINGS_URL + "?type=admin-panel&sub_type=immutable_basic");
}
export function getShipmentSettingsAdmin() {
  return axios.get(BASIC_SETTINGS_URL + "?type=admin-panel&sub_type=shipment_providers");
}
export function saveSettings(params, payload) {
  return axios.patch(BASIC_SETTINGS_URL, payload, { params });
}
export function getSettingsOptimize(params) {
  return axios.get(BASIC_SETTINGS_URL, { params });
}
export function getEmailSettingsAdmin() {
  return axios.get(BASIC_SETTINGS_URL + "?type=email&sub_type=portal_emails");
}
export function getEmailTriggerSettingsAdmin() {
  return axios.get(BASIC_SETTINGS_URL + "?type=admin-panel&sub_type=email_trigger");
}
export function getWhatsAppSMSConfigurations() {
  return axios.get(BASIC_SETTINGS_URL + "?type=notifications&sub_type=configurations");
}
export function getCustomPages() {
  return axios.get(GET_ALL_CUSTOM_PAGES_URL);
}
export function patchBasicSettingsPOS(body) {
  return axios.patch(BASIC_SETTINGS_URL + "?type=admin-panel&sub_type=pos", body);
}
export function getBasicSettingsPOS() {
  return axios.post(BASIC_SETTINGS_URL , {types:["admin-panel"], sub_types:["pos"]});
}
export function patchBasicSettings(body) {
  return axios.patch(BASIC_SETTINGS_URL, body);
}
export async function nmiKeysSetup(payload) {
  const response = await axios.post(`${NMI_AUTH_URL}`, payload);
  return response.data.message;
}
export function patchTaxSettings(body) {
  return axios.patch(BASIC_SETTINGS_URL + "?type=admin-panel&sub_type=tax", body)
}
export function patchBasicSettingsEcom(body) {
  return axios.patch(`${BASIC_SETTINGS_URL}?type=ecom&sub_type=${body?.sub_type}`, body);
}
export function patchThemeSettingsEcom(body) {
  return axios.patch(`${BASIC_SETTINGS_URL}?type=ecom&sub_type=${body?.sub_type}&force=1`, body);
}
export function patchBasicSettingsEcomRes(body) {
  return axios.patch(BASIC_SETTINGS_URL + "?type=ecom&sub_type=guest_user_restrictions", body);
}
export function patchUpdateCurrency(params, payload) {
  return axios.patch(`${CURRENCY_SETTINGS_URL}?type=${params.type}&sub_type=${params.sub_type}`, { ...payload });
}
export function postAutoApplyCredit(payload) {
  return axios.post(`${CURRENCY_SETTINGS_URL}auto-apply-credit`, payload);
}
export function postAutoApplyCreditSupplier(payload) {
  return axios.post(`${CURRENCY_SETTINGS_URL}auto-apply-credit-supplier`, payload);
}
export function getBackgroundTaskStatus(id) {
  return axios.get(`${BACKGROUND_TASK_STATUS}/${id}`);
}
export function getBackgroundTasksList(params) {
  return axios.get(BACKGROUND_TASK_STATUS, { params });
}
export function patchUpdateToggleSettings(params, payload) {
  return axios.patch(`${CURRENCY_SETTINGS_URL}?type=${params.type}&sub_type=${params.sub_type}`, { ...payload });
}
export function patchUpdateShipmentSettings(params, payload) {
  return axios.patch(`${BASIC_SETTINGS_URL}?type=${params.type}&sub_type=${params.sub_type}&force=${true}`, { ...payload });
}
export function patchUpdateEamilNotificationsSettings(params, payload) {
  return axios.patch(
    `${BASIC_SETTINGS_URL}?type=${params.type}&sub_type=${params.sub_type}&force=${true}`, 
    { ...payload }
  );
}
export function patchUpdateWhatsAppSMSConfigurationsSettings(params, payload) {
  return axios.patch(
    `${BASIC_SETTINGS_URL}?type=${params.type}&sub_type=${params.sub_type}&force=${true}`,
    { ...payload }
  );
}
export function getSettings(body) {
  const URL = body.public_key ? `${CURRENCY_SETTINGS_URL}?public_key=${body.public_key}` : CURRENCY_SETTINGS_URL;
  delete body.public_key;
  return axios.post(URL, { ...body });
}
export function getDragColumnListing(params) {
  return axios.get(`${BASIC_SETTINGS_URL}?type=${params.type}&sub_type=${params.sub_type}`);
}
export function patchDragColumnListing(params, payload) {
  return axios.patch(`${BASIC_SETTINGS_URL}?type=${params.type}&sub_type=${params.sub_type}&force=${params.force}&validate_columns=${[false, true, "false", "true"].includes(params?.validate_columns) ? params?.validate_columns : ""}`, {
    ...payload,
  });
}
// Banking bank-card layout (order + hidden account ids). Shares the generic
// settings_v2 endpoint with the grid column-persistence helpers above, but the
// payload is {order, hidden} — not column state. Named separately so callers
// (and the next reader) don't mistake it for drag-column config.
export function getBankingLayout(params) {
  return getDragColumnListing(params);
}
export function saveBankingLayout(params, payload) {
  return patchDragColumnListing(params, payload);
}
export function patchproductSOsetting(params, payload) {
  return axios.patch(`${BASIC_SETTINGS_URL}?type=${params.type}&sub_type=${params.sub_type}&force=${params.force}`, {
    ...payload,
  });
}
export function getproductSOsetting(params) {
  return axios.get(`${BASIC_SETTINGS_URL}?type=${params.type}&sub_type=${params.sub_type}`);
}
export function getProductListingColumnOrder(params) {
  return axios.get(`${BASIC_SETTINGS_URL}?type=${params.type}&sub_type=${params.sub_type}`);
}
export function patchProductListingColumnOrder(params, payload) {
  return axios.patch(`${BASIC_SETTINGS_URL}?type=${params.type}&sub_type=${params.sub_type}&force=${params.force}`, {
    ...payload,
  });
}
export  function PublicPayment(publicKey, payload){
  return axios.post(`${PUBLIC_PAYMENT_URL}?public_key=${publicKey}`,{
    ...payload
  })
}
export function getAllRegisterDevices(params = {}) {
  const defaultParams = {
    is_active: true,
    disable_connection_info: true,
    ...params
  };
  return axios.get(`${REGISTERED_DEVICES_URL}/list`, { params: defaultParams });
}
// NMI security keys (secrets never returned; each row carries a secret_hint).
export function getNmiKeys() {
  return axios.get(NMI_KEYS_URL);
}
// Pull every NMI key's device listing into the devices table.
export function syncRegisterDevices() {
  return axios.post(`${REGISTERED_DEVICES_URL}/sync`);
}
export function getIframesForWhatsappNotifications(params) {
  return axios.get(`${GET_IFRAMES_FOR_WHATSAPP_URL}`);
}
// Custom Payment Adjustments
export function createCustomPaymentAdjustment(body){
return axios.post(`${PAYMENT_ADJUSTMENT_TYPE_URL}`, body)
}
export function updateCustomPaymentAdjustmentType(id, body){
  return axios.put(`${PAYMENT_ADJUSTMENT_TYPE_URL}/${id}`, body)
}
export function deleteCustomPaymentAdjustmentType(id, body){
  return axios.delete(`${PAYMENT_ADJUSTMENT_TYPE_URL}/${id}`)
}
export function getCustomPaymentAdjustmentTypes(){
  return axios.get(`${PAYMENT_ADJUSTMENT_TYPE_URL}/list`)
}
export function getCustomPaymentAdjustmentTypeById(id){
  return axios.get(`${PAYMENT_ADJUSTMENT_TYPE_URL}/${id}`)
}
export function getAllAccounts (params = {}){
  return axios.get(`${GET_ALL_PAYMENT_ACCOUNTS}`, { params })
}
export function getCometChatSettings() {
  return axios.get(BASIC_SETTINGS_URL + "?type=admin-panel&sub_type=cometchat");
}
export function patchCometChatSettings(body) {
  return axios.patch(BASIC_SETTINGS_URL + "?type=admin-panel&sub_type=cometchat", body);
}